// /**
//  * =========================================================================================
//  * PERFORMANCE - Global Search
//  * =========================================================================================
//  *
//  **/
//
// import React, {useCallback, useEffect, useRef, useState} from 'react';
// import {useSelector} from 'react-redux';
// import {useHistory} from 'react-router-dom';
// import useSocket from "../../../app-account/common/useSocket";
// import {getLabelValue} from "ubs-framework/v2/common/selector";
// import * as Icon from 'ubs-icons';
// import {COLOR, LIMIT} from "ubs-framework/v2/common/constant";
// import {useEscKey} from "ubs-framework/v2/hooks";
// import {sendData} from "../../../store/actions";
// // import UEmployeeInfo from '../../../../../common/components/UEmployeeInfo';
// import UPopup from "ubs-framework/v2/UPopup";
// import UFilterSearch from "ubs-framework/v2/common/UFilters/UFilterSearch/UFilterSearch";
// import {PLAN} from 'ubs-framework/v2/common/constant';
//
// const GlobalSearch = ({open, closeSidebar}) => {
//     const searchRef = useRef();
//     const history = useHistory();
//     const _S_ID = useSelector(e => e.common.socketId);
//     const [candidateListOption, setCandidateListOption] = useState([]);
//     const [jobListOption, setJobListOption] = useState([]);
//
//     const _ORG_ID = useSelector(e => e.common.orgId);
//     const _UAC_J = useSelector(e => e?.performance?.uac?.jobs?.modules);
//     const _UAC_C = useSelector(e => e?.performance?.uac?.candidates?.modules);
//     const _DRL = useSelector(e => getLabelValue(e.ats?.disqualifyReasonList));
//
//     /** For up/down key navigation in search filter **/
//     let item_selected, index = -1, next;
//
//     const [allRoutes, setAllRoutes] = useState([
//         {name: 'workspace', route: `workspace`, isShow: false, isAccess: true},
//         {name: 'plans', route: `plans`, isShow: false, isAccess: true},
//
//     ]);
//
//     const [matchedRoutes, setMatchedRoutes] = useState([]);
//
//     const [allValues, setAllValues] = useState({
//         searchText: '',
//         isFocused: false
//     });
//
//     useEffect(() => {
//         // Keyboard Event - Keydown
//         document.addEventListener('keydown', keyDownEffect);
//         return () => document.removeEventListener('keydown', keyDownEffect);
//     }, []);
//
//     useEffect(() => {
//         setMatchedRoutes(allRoutes?.filter(route => route?.isShow && route?.isAccess));
//     }, [allRoutes]);
//
//     useEscKey(() => {
//         closeSidebar();
//     })
//
//     useEffect(() => {
//         refresh();
//         if (_UAC_C?.candidates?.action?.read?.value) {
//             sendData('ats|candidate|search', {search: '', globalSearch: true});
//         }
//         if (_UAC_J?.jobs?.action?.read?.value) {
//             sendData('ats|job|search', {search: '', globalSearch: true});
//         }
//         return () => {
//             off();
//         };
//     }, []);
//
//     const {off, refresh} = useSocket(res => {
//         if (!res.error && (res?.data?.socketId === _S_ID)) {
//             switch (res.event) {
//                 case 'ats|candidate|search':
//                     setCandidateListOption(res?.data?.list);
//                     break;
//                 case 'ats|job|search':
//                     setJobListOption(res?.data?.list);
//                     break;
//                 default:
//                     return true;
//             }
//         }
//     });
//     console.log("maaaaaa",matchedRoutes)
//
//     const handle = {
//         search: (text) => {
//             if (text?.length >= LIMIT.SEARCH_CHARACTER) {
//                 searchRef?.current?.open();
//             }
//             setAllValues({...allValues, searchText: text});
//
//             // For menu
//             let routes = allRoutes?.filter(route => route?.name?.toLowerCase()?.includes(text.toLowerCase().trim()) && route?.isAccess);
//             console.log("rotes",routes)
//
//             setMatchedRoutes(routes);
//             //    for Candidates
//             if (_UAC_C.candidates?.action?.read?.value) {
//                 sendData('ats|candidate|search', {search: text, globalSearch: true});
//                 refresh();
//             }
//             //    for Job
//             if (_UAC_J?.jobs?.action?.read?.value) {
//                 sendData('ats|job|search', {search: text, globalSearch: true});
//                 refresh();
//             }
//
//         },
//     }
//
//     const keyDownEffect = (event) => {
//         // all search results
//         let searchItem = document.querySelectorAll('.u_global-search-item');
//         if (document.activeElement.classList.contains('u_input') || document.activeElement.classList.contains('u_global-search-item')) {
//             if (searchItem.length > 0) {
//                 let len = searchItem.length - 1; // Length of total search results
//                 if (event.which === 40) {
//                     // down key pressed
//                     index++;
//                     if (item_selected) {
//                         // if any search result has focus
//                         next = searchItem[index];
//                         if (typeof next !== undefined && index <= len) {
//                             item_selected = next;
//                         } else {
//                             index = 0;
//                             item_selected = searchItem[0];
//                         }
//                         item_selected.focus();
//                     } else {
//                         // if any search result has does not have focus
//                         index = 0;
//                         item_selected = searchItem[0];
//                         item_selected.focus();
//                     }
//                 } else if (event.which === 38) {
//                     // Up key pressed
//                     if (item_selected) {
//                         // if any search result has focus
//                         index--;
//                         next = searchItem[index];
//                         if (typeof next !== undefined && index >= 0) {
//                             item_selected = next;
//                         } else {
//                             index = len;
//                             item_selected = searchItem[len];
//                         }
//                         item_selected.focus();
//                     } else {
//                         // if any search result has does not have focus
//                         index = 0;
//                         item_selected = searchItem[len];
//                         item_selected.focus();
//                     }
//                 }
//                 // If Enter key is pressed
//                 if (event.which === 13) {
//                     if (document.activeElement.classList.contains('u_global-search-item')) {
//                         index = -1;
//                         // Manual click for focused search result
//                         setTimeout(() => {
//                             document.activeElement.click();
//                         }, 500)
//                     }
//                 }
//             }
//         }
//
//         if ((event.metaKey || event.ctrlKey) && event.code === 'KeyK') {
//             event.preventDefault();
//             closeSidebar(true);
//             setTimeout(() => {
//                 setAllValues({...allValues, isFocused: true});
//                 searchRef?.current?.open();
//             }, 200);
//         }
//     }
//
//     const closeSearch = () => {
//         setAllValues({...allValues, searchText: ''});
//         searchRef?.current?.close();
//     }
//
//     const menuChange = (route) => {
//         console.log("rrrrrr",route)
//
//         closeSearch();
//         closeSidebar(false)
//         history.push(`/${_ORG_ID}/${route?.route}`);
//     }
//
//     const viewCandidates = (e) => {
//         closeSearch();
//         const name = Object.keys(P_DT).find(e => P_DT[e]) ?? 'details';
//         history.push(`/${_ORG_ID}/candidates/details/${e}/${name}`);
//     }
//
//     const viewJob = (e) => {
//         closeSearch();
//         const name = Object.keys(P_JDT).find(e => P_JDT[e]) ?? 'summary';
//         history.push(`/${_ORG_ID}/jobs/${e}/${name}`);
//     }
//
//     const seeMoreCandidates = () => {
//         closeSearch();
//         history.push(`/${_ORG_ID}/candidates/list`);
//     }
//
//     const seeMoreJob = () => {
//         closeSearch();
//         history.push(`/${_ORG_ID}/jobs`);
//     }
//
//     return (
//         <React.Fragment>
//             <div className={`u_global-search u_flex u_align-center ${open ? 'u_global-search-active' : ''}`}>
//
//                 {/*<span className="u_icon-rollover u_header-breadcrumb-arrow u_mr-10 u_cp" onClick={() => closeSidebar(false)}>*/}
//                 {/*    <Icon.LeftArrow size={16} fill={COLOR.u_blue}/>*/}
//                 {/*</span>*/}
//
//                 <UPopup
//                     params={{className: "u_tooltip_search", on: ['click'], ref: searchRef}}
//                     overlayStyle={{zIndex: 100004}}
//                     contentStyle={{zIndex: 100004}}
//                     desc={<div className="u_global-search-section">
//                         {
//                             matchedRoutes?.length !== 0 &&
//                             <div className="u_global-search-content u_global-search-content-menu">
//                                 <div className="u_global-search-header">
//                                     <span>Menu</span>
//                                 </div>
//                                 <ul>
//                                     {
//                                         matchedRoutes?.slice(0, 5)?.map((route, i) => {
//                                             return <li key={i} className="u_global-search-item" tabIndex="-1" onClick={() => menuChange(route)}>{route?.name}</li>
//                                         })
//                                     }
//                                 </ul>
//                             </div>
//                         }
//                         {
//                             jobListOption?.length !== 0 &&
//                             <div className="u_global-search-content u_global-search-content-menu">
//                                 <div className="u_global-search-header">
//                                     <span>Jobs</span>
//                                 </div>
//                                 <ul>
//                                     {
//                                         jobListOption?.slice(0, 5)?.map(job => {
//                                             return <li key={job?._id} className="u_global-search-item u_flex u_align-center" tabIndex="-1"
//                                                        onClick={() => viewJob(job?._id)}>{job?.name}
//                                             </li>
//                                         })
//                                     }
//                                 </ul>
//                                 <span className="u_label u_color-blue u_px-15 u_py-7 u_cp" onClick={seeMoreJob}>See More Job</span>
//                             </div>
//                         }
//                         {
//                             candidateListOption?.length !== 0 &&
//                             <div className="u_global-search-content u_global-search-content-employee">
//                                 <div className="u_global-search-header">
//                                     <span>Candidates</span>
//                                 </div>
//                                 <ul>
//                                     {
//                                         candidateListOption?.slice(0, 5)?.map(candidate => {
//                                             return <li key={candidate?._id} className="u_global-search-item u_flex u_align-center" tabindex="-1"
//                                                        onClick={() => viewCandidates(candidate?._id)}>
//                                                 {/*<UEmployeeInfo size={26} employee={candidate}/>*/}
//                                                 {candidate?.isQuicklyAdded && <UPopup
//                                                     params={{className: "u_tooltip"}}
//                                                     desc={<span>Quick Added</span>}
//                                                 >
//                                                     <div className="u_badge-label u_badge-label__orange">Q</div>
//                                                 </UPopup>}
//                                                 {candidate?.isRejected && <UPopup
//                                                     params={{className: "u_tooltip"}}
//                                                     desc={<span>Rejected: {_DRL?.find(_ => _?.value === candidate?.disqualifyReason)?.name ?? '-'}</span>}
//                                                 >
//                                                     <div className="u_badge-label u_badge-label__red">R</div>
//                                                 </UPopup>}
//                                                 {candidate?.isSelected && <UPopup
//                                                     params={{className: "u_tooltip"}}
//                                                     desc={<span>Selected</span>}
//                                                 >
//                                                     <div className="u_badge-label u_badge-label__green">S</div>
//                                                 </UPopup>}
//                                                 {candidate?.isNew && <UPopup
//                                                     params={{className: "u_tooltip"}}
//                                                     desc={<span>New</span>}
//                                                 >
//                                                     <div className="u_badge-label u_badge-label__green">New</div>
//                                                 </UPopup>}
//                                             </li>
//                                         })
//                                     }
//                                 </ul>
//
//                                 <span className="u_label u_color-blue u_px-15 u_py-7 u_cp" onClick={seeMoreCandidates}>See More Candidates</span>
//                             </div>
//                         }
//
//                         {
//                             (matchedRoutes?.length === 0 && candidateListOption?.length === 0 && jobListOption?.length === 0) && <p className="u_p-15">No Result Found.</p>
//                         }
//                     </div>
//                     }
//                 >
//
//                     <div className="u_global-search-input">
//                         <form autoComplete="off" onSubmit={e => e?.preventDefault()}>
//                             <UFilterSearch
//                                 search={allValues?.searchText}
//                                 onSearch={search => handle.search(search)}
//                                 focus={allValues?.isFocused}
//                                 blur={() => setAllValues({...allValues, isFocused: false})}
//                                 placeholder={`Search for Menu...`}
//                                 minLength={2}
//                             />
//                         </form>
//                     </div>
//
//                 </UPopup>
//
//             </div>
//         </React.Fragment>
//     )
// }
//
// export default GlobalSearch;


/**
 * =========================================================================================
 * APP-ACCOUNT - Global Search
 * =========================================================================================
 *
 **/

import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import useSocket from "../../../app-account/common/useSocket";
import * as Icon from 'ubs-icons';
import {COLOR, LIMIT, PLAN} from "ubs-framework/v2/common/constant";
import {useEscKey} from "ubs-framework/v2/hooks";
import {sendData} from "../../../store/actions";
import UPopup from "ubs-framework/v2/UPopup";
import UFilterSearch from "ubs-framework/v2/common/UFilters/UFilterSearch/UFilterSearch";
import usePlan from '../../../common/hooks/usePlan';
import {ORG_OVERVIEW_USER_IDS} from '../../../common/constant';

const GlobalSearch = ({open, closeSidebar}) => {
    const searchRef = useRef();
    const history = useHistory();
    const _S_ID = useSelector(e => e.common.socketId);
    const [candidateListOption, setCandidateListOption] = useState([]);
    const [jobListOption, setJobListOption] = useState([]);

    const _ORG_ID = useSelector(e => e.common.orgId);
    const _PI = useSelector(e => e?.common?.planInfo);
    const _OWI = useSelector(e => e?.common?.ownerId);
    const _ID = useSelector(e => e?.common?._id);
    const _C_ORG = useSelector(e => e?.common?.currentOrg);
    const _ADMIN = useSelector(e => e?.common?.isAdmin);
    const _UAC_J = useSelector(e => e?.performance?.uac?.jobs?.modules);
    const _UAC_C = useSelector(e => e?.performance?.uac?.candidates?.modules);
    const _UT = useSelector(e => {
        const userType = e?.common?.orgList?.find(_ => _?.orgId === e?.common?.orgId)?.userType
        return (userType?.hrms === 3 || userType?.recruit === 1 || userType?.pms === 3)
    });
    const _WALLET_GATE = useSelector(e => e?.common?.walletBillingGate);
    const __plan = usePlan();
    const _WI_HRMS = __plan(PLAN?.whatsappIntegration, 'and', 'hrms')
    const _WI_REC = __plan(PLAN?.whatsappIntegration, 'and', 'recruit')
    const _WI_PMS = __plan(PLAN?.whatsappIntegration, 'and', 'pms')
    const _AP_LINK = __plan(PLAN?.aadhaarPanLinkStatus, 'and', 'hrms')
    const _AP_VERIFY = __plan(PLAN?.aadhaarCardVerification, 'and', 'hrms')
    const _PAN_V = __plan(PLAN?.panCardVerification, 'and', 'hrms')

    const allRoutes = useMemo(() => {
        const isTrialOwner = !!(_PI?.isTrialAccount && _OWI === _ID);
        const isProductAdmin = _OWI === _ID || !!_UT;
        const hasWallet = !!_WALLET_GATE?.hasAccess;
        const billingTabs = _WALLET_GATE?.tabs
            || (hasWallet ? {dashboard: true, wallet: true, history: true, invoices: true, receipts: true, reports: true, tdsClaim: true} : {});
        const billing = (name, route, tab) => ({name, route, isAccess: hasWallet && !!billingTabs?.[tab]});

        return [
            {name: 'Workspace', route: `manage/workspace`, isAccess: true},
            {name: 'Organization Overview', route: `manage/organization-overview`, isAccess: ORG_OVERVIEW_USER_IDS.includes(_ID)},
            {name: 'Active Sessions', route: `manage/active-sessions`, isAccess: true},
            {name: 'Active Sessions Report', route: `manage/active-sessions-report`, isAccess: isProductAdmin},
            {
                name: 'API Usage Monitor',
                route: `manage/api-usage-monitor`,
                isAccess: isProductAdmin && (_WI_REC || _WI_HRMS || _AP_LINK || _AP_VERIFY || _PAN_V || _WI_PMS),
            },
            {name: 'Pricing Plans', route: `manage/pricing-plan`, isAccess: isTrialOwner},
            {name: 'Subscriptions / All Payments', route: `manage/subscriptions/payments`, isAccess: isTrialOwner},
            {name: 'Subscriptions / Payment Methods', route: `manage/subscriptions/payment-method`, isAccess: isTrialOwner},
            {name: 'Subscriptions / Activity', route: `manage/subscriptions/activity`, isAccess: isTrialOwner},
            billing('Billing / Dashboard', `manage/billing/dashboard`, 'dashboard'),
            billing('Billing / Wallet', `manage/billing/wallet`, 'wallet'),
            billing('Billing / History', `manage/billing/history`, 'history'),
            billing('Billing / Invoices', `manage/billing/invoices`, 'invoices'),
            billing('Billing / Receipts', `manage/billing/receipts`, 'receipts'),
            billing('Billing / Reports', `manage/billing/reports`, 'reports'),
            billing('Billing / TDS Claim', `manage/billing/tds-claim`, 'tdsClaim'),
        ];
    }, [_ID, _OWI, _UT, _PI, _WALLET_GATE, _WI_HRMS, _WI_REC, _WI_PMS, _AP_LINK, _AP_VERIFY, _PAN_V]);

    const [allValues, setAllValues] = useState({
        searchText: '',
        isFocused: false
    });

    const matchedRoutes = useMemo(() => {
        const text = allValues?.searchText?.toLowerCase()?.trim() || '';
        return allRoutes?.filter(route => route?.isAccess && (!text || route?.name?.toLowerCase()?.includes(text)));
    }, [allRoutes, allValues?.searchText]);

    useEffect(() => {
        // Keyboard Event - Keydown
        document.addEventListener('keydown', keyDownEffect);
        return () => document.removeEventListener('keydown', keyDownEffect);
    }, []);

    useEscKey(() => {
        closeSidebar();
    });

    useEffect(() => {
        refresh();
        // Only search if permissions exist
        if (_UAC_C?.candidates?.action?.read?.value) {
            sendData('ats|candidate|search', {search: '', globalSearch: true});
        }
        if (_UAC_J?.jobs?.action?.read?.value) {
            sendData('ats|job|search', {search: '', globalSearch: true});
        }
        return () => {
            off();
        };
    }, []);

    const {off, refresh} = useSocket(res => {
        if (!res.error && (res?.data?.socketId === _S_ID)) {
            switch (res.event) {
                case 'ats|candidate|search':
                    setCandidateListOption(res?.data?.list || []);
                    break;
                case 'ats|job|search':
                    setJobListOption(res?.data?.list || []);
                    break;
                default:
                    return true;
            }
        }
    });

    const handle = {
        search: (text) => {
            if (text?.length >= LIMIT.SEARCH_CHARACTER) {
                searchRef?.current?.open();
            }
            setAllValues({...allValues, searchText: text});

            // For Candidates search (if permissions exist)
            if (_UAC_C?.candidates?.action?.read?.value) {
                sendData('ats|candidate|search', {search: text, globalSearch: true});
                refresh();
            }
            // For Job search (if permissions exist)
            if (_UAC_J?.jobs?.action?.read?.value) {
                sendData('ats|job|search', {search: text, globalSearch: true});
                refresh();
            }
        },
    }

    const keyDownEffect = (event) => {
        let searchItem = document.querySelectorAll('.u_global-search-item');

        if (document.activeElement.classList.contains('u_input') ||
            document.activeElement.classList.contains('u_global-search-item')) {

            if (searchItem.length > 0) {
                let len = searchItem.length - 1;
                let item_selected, index = -1, next;

                if (event.which === 40) { // down key
                    index++;
                    if (item_selected) {
                        next = searchItem[index];
                        if (typeof next !== 'undefined' && index <= len) {
                            item_selected = next;
                        } else {
                            index = 0;
                            item_selected = searchItem[0];
                        }
                    } else {
                        index = 0;
                        item_selected = searchItem[0];
                    }
                    item_selected.focus();
                } else if (event.which === 38) { // up key
                    if (item_selected) {
                        index--;
                        next = searchItem[index];
                        if (typeof next !== 'undefined' && index >= 0) {
                            item_selected = next;
                        } else {
                            index = len;
                            item_selected = searchItem[len];
                        }
                    } else {
                        index = 0;
                        item_selected = searchItem[len];
                    }
                    item_selected.focus();
                }

                if (event.which === 13) { // enter key
                    if (document.activeElement.classList.contains('u_global-search-item')) {
                        index = -1;
                        setTimeout(() => {
                            document.activeElement.click();
                        }, 100);
                    }
                }
            }
        }

        if ((event.metaKey || event.ctrlKey) && event.code === 'KeyK') {
            event.preventDefault();
            closeSidebar(true);
            setTimeout(() => {
                setAllValues({...allValues, isFocused: true});
                searchRef?.current?.open();
            }, 200);
        }
    }

    const closeSearch = () => {
        setAllValues({...allValues, searchText: ''});
        searchRef?.current?.close();
    }

    const menuChange = (route) => {
        closeSearch();
        closeSidebar(false);
        history.push(`/${_ORG_ID}/${route?.route}`);
    }

    const viewCandidates = (candidateId) => {
        closeSearch();
        history.push(`/${_ORG_ID}/candidates/details/${candidateId}/details`);
    }

    const viewJob = (jobId) => {
        closeSearch();
        history.push(`/${_ORG_ID}/jobs/${jobId}/summary`);
    }

    const seeMoreCandidates = () => {
        closeSearch();
        history.push(`/${_ORG_ID}/candidates/list`);
    }

    const seeMoreJob = () => {
        closeSearch();
        history.push(`/${_ORG_ID}/jobs`);
    }

    return (
        <React.Fragment>
            <div className={`u_global-search u_flex u_align-center ${open ? 'u_global-search-active' : ''}`}>

                <span className="u_icon-rollover u_header-breadcrumb-arrow u_mr-10 u_cp" onClick={() => closeSidebar(false)}>
                    <Icon.LeftArrow size={16} fill={COLOR.u_blue}/>
                </span>

                <UPopup
                    params={{className: "u_tooltip_search", on: ['click'], ref: searchRef}}
                    overlayStyle={{zIndex: 100004}}
                    contentStyle={{zIndex: 100004}}
                    desc={
                        <div className="u_global-search-section">
                            {
                                matchedRoutes?.length !== 0 &&
                                <div className="u_global-search-content u_global-search-content-menu">
                                    <div className="u_global-search-header">
                                        <span>Menu</span>
                                    </div>
                                    <ul>
                                        {
                                            matchedRoutes?.slice(0, 5)?.map((route, i) => {
                                                return <li key={i} className="u_global-search-item" tabIndex="-1" onClick={() => menuChange(route)}>{route?.name}</li>
                                            })
                                        }
                                    </ul>
                                </div>
                            }
                            {
                                jobListOption?.length !== 0 &&
                                <div className="u_global-search-content u_global-search-content-menu">
                                    <div className="u_global-search-header">
                                        <span>Jobs</span>
                                    </div>
                                    <ul>
                                        {
                                            jobListOption?.slice(0, 5)?.map(job => {
                                                return <li key={job?._id} className="u_global-search-item u_flex u_align-center" tabIndex="-1"
                                                           onClick={() => viewJob(job?._id)}>{job?.name}
                                                </li>
                                            })
                                        }
                                    </ul>
                                    <span className="u_label u_color-blue u_px-15 u_py-7 u_cp" onClick={seeMoreJob}>See More Job</span>
                                </div>
                            }

                            {candidateListOption?.length !== 0 && (
                                <div className="u_global-search-content u_global-search-content-employee">
                                    <div className="u_global-search-header">
                                        <span>Candidates</span>
                                    </div>
                                    <ul>
                                        {candidateListOption?.slice(0, 5)?.map(candidate => (
                                            <li key={candidate?._id}
                                                className="u_global-search-item u_flex u_align-center"
                                                tabIndex="-1"
                                                onClick={() => viewCandidates(candidate?._id)}
                                            >
                                                 {/*<UEmployeeInfo size={26} employee={candidate}/> */}
                                                <span>{candidate?.name || 'Unknown Candidate'}</span>

                                                {/* Candidate badges */}
                                                {candidate?.isQuicklyAdded && (
                                                    <UPopup params={{className: "u_tooltip"}} desc={<span>Quick Added</span>}>
                                                        <div className="u_badge-label u_badge-label__orange">Q</div>
                                                    </UPopup>
                                                )}
                                                {candidate?.isRejected && (
                                                    <UPopup params={{className: "u_tooltip"}} desc={<span>Rejected</span>}>
                                                        <div className="u_badge-label u_badge-label__red">R</div>
                                                    </UPopup>
                                                )}
                                                {candidate?.isSelected && (
                                                    <UPopup params={{className: "u_tooltip"}} desc={<span>Selected</span>}>
                                                        <div className="u_badge-label u_badge-label__green">S</div>
                                                    </UPopup>
                                                )}
                                                {candidate?.isNew && (
                                                    <UPopup params={{className: "u_tooltip"}} desc={<span>New</span>}>
                                                        <div className="u_badge-label u_badge-label__green">New</div>
                                                    </UPopup>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                    <span className="u_label u_color-blue u_px-15 u_py-7 u_cp" onClick={seeMoreCandidates}>See More Candidates</span>
                                </div>
                            )}
                            {(matchedRoutes?.length === 0 && candidateListOption?.length === 0 && jobListOption?.length === 0 && allValues.searchText.length > 0) && (
                                <p className="u_p-15">No Result Found.</p>
                            )}
                        </div>
                    }
                >
                    <div className="u_global-search-input">
                        <form autoComplete="off" onSubmit={e => e?.preventDefault()}>
                            <UFilterSearch
                                search={allValues?.searchText}
                                onSearch={search => handle.search(search)}
                                focus={allValues?.isFocused}
                                blur={() => setAllValues({...allValues, isFocused: false})}
                                placeholder={`Search for Menu...`}
                                minLength={2}
                            />
                        </form>
                    </div>
                </UPopup>
            </div>
        </React.Fragment>
    )
}

export default GlobalSearch;
